import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
  hideNav?: boolean;
  heroSlot?: React.ReactNode;
}

const Layout = ({ children, hideNav = false, heroSlot }: LayoutProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on page load/refresh
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (hideNav) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      {heroSlot}
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
